/* 手繪 SVG 圖示，一致筆畫與端點。刻意不用 emoji 或 unicode 符號當圖示。 */
import type { ReactNode } from "react";

const PATHS: Record<string, ReactNode> = {
  search: <><circle cx="8.5" cy="8.5" r="5" /><path d="M12.5 12.5 17 17" /></>,
  lock: <><rect x="4.5" y="9" width="11" height="7.5" /><path d="M7.5 9V6.5a2.5 2.5 0 0 1 5 0V9" /></>,
  unlock: <><rect x="4.5" y="9" width="11" height="7.5" /><path d="M7.5 9V6.5a2.5 2.5 0 0 1 4.6-1.3" /></>,
  more: <><circle cx="4.5" cy="10" r="1.1" /><circle cx="10" cy="10" r="1.1" /><circle cx="15.5" cy="10" r="1.1" /></>,
  close: <path d="M5 5l10 10M15 5L5 15" />,
  net: <><circle cx="10" cy="4.5" r="2.2" /><circle cx="4.5" cy="15" r="2.2" /><circle cx="15.5" cy="15" r="2.2" /><path d="M8.6 6.4 5.7 12.9M11.4 6.4l2.9 6.5M6.7 15h6.6" /></>,
  export: <><path d="M10 3v9M6.5 8.5 10 12l3.5-3.5M3.5 15.5h13" /></>,
  peel: <><path d="M3.5 6.5h9l4 4v3" /><path d="M3.5 6.5v7h9" /><path d="M12.5 6.5v4h4" /></>,
  check: <path d="M4 10.5 8 14.5 16 5.5" />,
  warn: <><path d="M10 3.5 17.5 16.5h-15z" /><path d="M10 8v4M10 14.2v.6" /></>,
  trash: <><path d="M4 6.5h12M8 6.5V4.5h4v2M6 6.5l.8 10h6.4l.8-10" /></>,
  history: <><circle cx="10" cy="10" r="6.5" /><path d="M10 6v4.3l3 2" /></>,
  tray: <><path d="M3 12h3.5l1 2h5l1-2H17v4H3z" /><path d="M3 12l2-6h10l2 6" /></>,
  cloud: <><path d="M6 15.5a3.5 3.5 0 0 1 .4-7 4.5 4.5 0 0 1 8.6 1.2A3.2 3.2 0 0 1 14.5 15.5z" /></>,
  sync: <><path d="M4 10a6 6 0 0 1 10.2-4.2M16 10a6 6 0 0 1-10.2 4.2" /><path d="M14.5 3.5v2.6h-2.6M5.5 16.5v-2.6h2.6" /></>,
  key: <><circle cx="7" cy="13" r="3.2" /><path d="M9.4 10.6 15.5 4.5M13 7l2 2M11.2 8.8l2 2" /></>,
  copy: <><rect x="6.5" y="6.5" width="9" height="9" /><path d="M4 13V4h9" /></>,
};

export function Icon({ name }: { name: keyof typeof PATHS | string }) {
  return (
    <svg className="ico" viewBox="0 0 20 20" aria-hidden="true">
      {PATHS[name] ?? PATHS["warn"]}
    </svg>
  );
}
